module.exports = __webpack_public_path__ + "static/media/afrinovator logo-11.24fcae05.png";